/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getEduvanceAiUsers = /* GraphQL */ `
  query GetEduvanceAiUsers($User: String!) {
    getEduvanceAiUsers(User: $User) {
      User
      expiry
      type
    }
  }
`;
export const listEduvanceAiUsers = /* GraphQL */ `
  query ListEduvanceAiUsers(
    $filter: TableEduvanceAiUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEduvanceAiUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        User
        expiry
        type
      }
      nextToken
    }
  }
`;
export const getEduvanceAITool = /* GraphQL */ `
  query GetEduvanceAITool($projectname: String!) {
    getEduvanceAITool(projectname: $projectname) {
      extraField1
      projectname
      projectData
      projectType
      user
    }
  }
`;
export const listEduvanceAITools = /* GraphQL */ `
  query ListEduvanceAITools(
    $filter: TableEduvanceAIToolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEduvanceAITools(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        projectname
        projectType
        user
      }
      nextToken
    }
  }
`;
